<template>
    <div>
        <b-tabs class="mt-2" content-class="mt-3 ml-2 mr-2">
            <b-tab>
                <template v-slot:title >
                    <h5 class="font-en mt-1 mb-1"><i class="fa fa-id-card-o mr-2" aria-hidden="true" />Application</h5>
                </template>
                <div class="row">
                    <div class="col-sm-12 col-lg-12 col-md-12 col-xl-4">
                        <b-card>
                            <b-card-body>
                                <b-media class="mb-3">
                                    <template #aside>
                                        <img src="@/assets/img/icon_jobfair_1.png" alt="MUIC">
                                    </template>
                                    <h4 class="font-en mt-4">Job Application</h4>
                                </b-media>
                                <b-alert variant="danger" class="mt-2 mb-2" show>
                                    <h5 class="ml-2 mr-2 font-eng mt-1 mb-1 text-capitalize">
                                        <strong>Consent for the Disclosure of Personal Information</strong>
                                    </h5>
                                    <p class="ml-2 mr-2 mt-2 mb-1 text-dark font-eng f-textSize-1">
                                        This Agreement is made and effective once I submit the form. I, as a Mahidol University International College student/alumni, hereby authorize Mahidol University International College to collect, use and disclose my information and quality of my performance for employment purposes to the companies registered with Mahidol University International College.
                                    </p>
                                    <b-collapse id="collapse-a" class="mt-2">
                                        <p class="ml-2 mr-2 mt-2 mb-1 text-dark font-eng f-textSize-1">
                                            I understand that this information is considered a student record. Further, I understand that by signing this release, I am waiving my right to keep this information confidential from the above personnel.
                                        </p>
                                    </b-collapse>
                                    <b-collapse id="collapse-b" class="mt-2">
                                        <p class="ml-2 mr-2 mt-2 mb-1 text-dark font-eng f-textSize-1">
                                            I certify that my consent for the release of this information is entirely voluntary. I certify that I understand this consent to release can be revoked by me at any time in writing but will not be effective for materials already released under it.
                                        </p>
                                    </b-collapse>
                                    <b-link @click="visibleCollege = !visibleCollege" v-b-toggle.collapse-a.collapse-b class="font-eng ml-2">
                                        <strong v-if="visibleCollege" class="text-blue-cus">read more...</strong>
                                        <strong v-else class="text-red-cus">close read more</strong>
                                    </b-link>
                                    <hr>
                                    <b-form-checkbox
                                        class="ml-2 mr-2 mb-2 text-dark font-eng"
                                        id="checkbox-1"
                                        @change="valConsent"
                                        v-model="pdpaStatus_1"
                                        name="checkbox-1"
                                        value="accept"
                                        unchecked-value="not accept"
                                    >
                                        <span class="font-weight-bold text-dark font-eng">I accept the terms and use Confirm the recordings with the college.</span>
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        class="ml-2 mr-2 text-dark font-eng"
                                        id="checkbox-2"
                                        @change="valConsentCompany"
                                        v-model="pdpaStatus_2"
                                        name="checkbox-2"
                                        value="accept"
                                        unchecked-value="not accept"
                                        :disabled="pdpaStatus_1 === 'not accept' ? true : false"
                                    >
                                        <span :class="{ 'text-muted' : pdpaStatus_1 === 'not accept' , 'text-dark font-weight-bold' : pdpaStatus_1 === 'accept'  }" class="font-eng">I accept the terms and use Consent to send information to the company</span>
                                    </b-form-checkbox>
                                    <p class="ml-2 mr-2 mt-2 mb-1 text-dark font-eng f-textSize-1">
                                        Mahidol University International College and the prospective companies warrant that your information shall not be used for other purposes or disclosed to any third party not relevant to the aforementioned purpose.
                                    </p>
                                </b-alert>
                                <!-- notti data periods -->
                                    <!-- {{ NotiiDataPeriodsshow(logCrated) }} -->
                                    <b-alert v-if="NotiiDataPeriodsshow(logCrated)" variant="danger" class="font-eng mt-2 mb-2" show>
                                        The information has not been updated for more than 6 months. Please update the information.
                                    </b-alert>
                                <!-- notti data periods -->
                                <div v-if="pdpaStatus_1 === 'accept'">
                                    <!-- <hr> -->
                                    <h4 class="text-danger font-en font-weight-bold"><u>Applicant’s Profile</u></h4>
                                    <p class="font-en mt-1 mb-2">
                                        The information below will be sent to the Human Resource Department</span> of the company you are applying in. 
                                        Please write your personal information and contact details properly so that the company can contact you back.
                                    </p>
                                    <p class="text-danger font-en mt-2 mb-2">
                                        You can't upload files larger than 10 MB. 
                                        Exceeding the limit of 10MB, your application will not be sent to the companies.
                                    </p>
                                    <span class="hide-load-upfile">{{ parseFloat(size_file_sum).toFixed(2) }}</span>
                                    <b-progress :max="max" animated>
                                        <b-progress-bar :variant="sumAllFile > 9 ? 'warning' : 'primary'" :value="sumAllFile" :label="`${((sumAllFile / max) * 100).toFixed(2)}%`"></b-progress-bar>
                                    </b-progress>
                                    <!-- Resume -->
                                    <h5 class="font-en mt-3 mb-1"><strong>Resume <span class="text-danger">* </span></strong></h5>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <b-media>
                                                <template #aside vertical-align="center">
                                                    <i class="text-muted mt-1 fa fa-file-pdf-o fa-2x" aria-hidden="true" />
                                                </template>
                                                <p class="font-th mt-2 mb-1">
                                                    <b-link v-if="file_2" target="_blank" :href="file_2" class="font-th mt-1 mb-1 ml-1">
                                                        Resume <span class="text-muted"><small>( file size {{ size_file_resume+` mb` }} )</small></span>
                                                    </b-link>
                                                    <span v-else class="font-en text-danger" >File upload</span>
                                                    <br>
                                                    <span class="font-en text-danger" v-if="errorPdfFile !== ''">{{ errorPdfFile }}</span>
                                                </p>
                                            </b-media>
                                        </div>
                                        <b-button-group>
                                            <b-button @click="$refs.fileInput3.$el.querySelector('input[type=file]').click()" variant="info" class="text-capitalize" size="sm">
                                                <i class="fa fa-upload" aria-hidden="true" />
                                            </b-button>
                                            <b-button @click="delfileData('delResume')" variant="danger" class="text-capitalize" size="sm"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                        </b-button-group>
                                        <b-form-file @change="UploadfileData($event, 'Resume')" ref="fileInput3" v-model="formData.FileCv" style="display:none;" />
                                    </div>
                                    <!-- Transcript -->
                                    <h5 class="mt-3"><strong>Transcript</strong></h5>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <b-media>
                                                <template #aside vertical-align="center">
                                                    <i class="text-muted mt-1 fa fa-file-pdf-o fa-2x" aria-hidden="true" />
                                                </template>
                                                <p class="font-th mt-2 mb-1">
                                                    <b-link v-if="file_1" target="_blank" :href="file_1" class="font-th mt-1 mb-1 ml-1">
                                                        Transcript <span class="text-muted"><small>( file size {{ size_file_transcipt+` mb` }} )</small></span>
                                                    </b-link>
                                                    <span v-else class="font-en text-danger" >File upload</span>
                                                    <br>
                                                    <span class="font-en text-danger" v-if="errorPdfFileTranscript !== ''">{{ errorPdfFileTranscript }}</span>
                                                </p>
                                            </b-media>
                                        </div>
                                        <b-button-group>
                                            <b-button @click="$refs.fileInput2.$el.querySelector('input[type=file]').click()" variant="info" class="text-capitalize" size="sm">
                                                <i class="fa fa-upload" aria-hidden="true" />
                                            </b-button>
                                            <b-button @click="delfileData('delTranscript')" variant="danger" class="text-capitalize" size="sm"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                        </b-button-group>
                                        <b-form-file @change="UploadfileData($event, 'Transcript')" ref="fileInput2" v-model="formData.FileTranscript" style="display:none;" />
                                    </div>
                                    <!-- Certificate -->
                                    <h5 class="font-en mt-4 mb-1"><strong>Certificate</strong></h5>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <b-media>
                                                <template #aside vertical-align="center">
                                                    <i class="text-muted mt-1 fa fa-file-pdf-o fa-2x" aria-hidden="true" />
                                                </template>
                                                <p class="font-th mt-2 mb-1">
                                                    <b-link v-if="file_3" target="_blank" :href="file_3" class="font-th mt-1 mb-1 ml-1">
                                                        Certificate <span class="text-muted"><small>( file size {{ size_file_certificate+` mb` }} )</small></span>
                                                    </b-link>
                                                    <span v-else class="font-en text-danger" >File upload</span>
                                                    <br>
                                                    <span class="font-en text-danger" v-if="errorPdfFileCerificate !== ''">{{ errorPdfFileCerificate }}</span>
                                                </p>
                                            </b-media>
                                        </div>
                                        <b-button-group>
                                            <b-button @click="$refs.fileInput4.$el.querySelector('input[type=file]').click()" variant="info" class="text-capitalize" size="sm">
                                                <i class="fa fa-upload" aria-hidden="true" />
                                            </b-button>
                                            <b-button @click="delfileData('delCertificate')" variant="danger" class="text-capitalize" size="sm"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                        </b-button-group>
                                        <b-form-file @change="UploadfileData($event, 'Certificate')" ref="fileInput4" v-model="formData.FileCerificate" style="display:none;" />
                                    </div>
                                    <!-- image -->
                                    <h5 class="mt-3"><strong>Photo</strong></h5>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <b-media>
                                                <template #aside vertical-align="center">
                                                    <!-- <b-img blank blank-color="#ccc" width="64" round="circle" alt="placeholder"></b-img> -->
                                                    <i class="text-muted mt-1 fa fa-photo fa-2x" aria-hidden="true" />
                                                </template>
                                                <p class="font-th mt-2 mb-1">
                                                    <b-link v-if="file_0" target="_blank" :href="file_0" class="font-th mt-1 mb-1 ml-1">
                                                        Image <span class="text-muted"><small>( file size {{ size_file_img+` mb` }} )</small></span>
                                                    </b-link>
                                                    <span v-else class="font-en text-danger" >File upload</span>
                                                    <br>
                                                    <span class="font-en text-danger" v-if="errorImage !== ''">{{ errorImage }}</span>
                                                </p>
                                            </b-media>
                                        </div>
                                        <b-button-group>
                                            <b-button @click="$refs.fileInput1.$el.querySelector('input[type=file]').click()" variant="info" class="text-capitalize" size="sm">
                                                <i class="fa fa-upload" aria-hidden="true" />
                                            </b-button>
                                            <b-button @click="delfileData('delImage')" variant="danger" class="text-capitalize" size="sm"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                        </b-button-group>
                                        <b-form-file @change="UploadfileData($event, 'photo')" ref="fileInput1" v-model="formData.FilePhoto" style="display:none;" />
                                    </div>
                                    <!-- first name -->
                                    <h5 class="mt-4 mb-0 font-en text-muted text-capitalize">Name - Surname<span class="ml-1 text-danger">*</span></h5>
                                    <div v-if="boxName" >
                                        <span class="f-textSize-0 font-th mt-0">
                                            {{ chkBlankData(formData.inputName) }}
                                            <b-badge size="sm" @click="boxName = !boxName" class="align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputName" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('nameUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- last name -->
                                    <div v-if="boxLastName" >
                                        <span class="f-textSize-0 font-th mt-0">
                                            {{ chkBlankData(formData.inputLastName) }}
                                            <b-badge size="sm" @click="boxLastName = !boxLastName" class="align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputLastName" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('lastnameUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- Nationality -->
                                    <h5 class="mt-3 mb-1 font-en text-muted text-capitalize">Nationality<span class="ml-1 text-danger">*</span></h5>
                                    <div v-if="boxNational" >
                                        <span class="f-textSize-0 font-th mt-0">
                                            {{ chkBlankData(formData.inputNation) }}
                                            <b-badge @click="boxNational = !boxNational" class="align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputNation" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('nationalUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- Major -->
                                    <h5 class="mt-3 mb-1 font-en text-muted text-capitalize">Major<span class="ml-1 text-danger">*</span></h5>
                                    <div v-if="boxMajor" >
                                        <span class="f-textSize-0 font-th mt-0">
                                            {{ chkBlankData(formData.inputMajor) }}
                                            <b-badge @click="boxMajor = !boxMajor" class="align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputMajor" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('majorUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- GPA -->
                                    <h5 class="mt-3 mb-1 font-en text-muted text-capitalize">Grade<span class="ml-1 text-danger">*</span></h5>
                                    <div v-if="boxGpa">
                                        <span class="f-textSize-0 font-th mt-0">
                                            {{ chkBlankData(formData.inputGpa) }}
                                            <b-badge @click="boxGpa = !boxGpa" class="align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputGpa" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('gradeUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- Area of Interest -->
                                    <h5 class="mt-3 mb-1 font-en text-muted text-capitalize">Area of Interest<span class="ml-1 text-danger">*</span></h5>
                                    <div v-if="boxArea" >
                                        <span class="f-textSize-0 font-th mt-0">
                                            {{ chkBlankData(formData.inputArea) }}
                                            <b-badge @click="boxArea = !boxArea" class="align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputArea" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('AreaUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- mail -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Email<span class="ml-1 text-danger">*</span></h5>
                                    <div v-if="boxMail" >
                                        <span class="f-textSize-0 font-th mt-0">
                                            {{ chkBlankData(formData.inputMail) }}
                                            <b-badge @click="boxMail = !boxMail" class="align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputMail" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('mailUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- <small class="font-en text-muted">Please enter an email So that the company can contact and send information back to you</small> -->
                                    <!-- Telephone -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Phone Number<span class="ml-1 text-danger">*</span></h5>
                                    <div v-if="boxPhone" >
                                        <span class="f-textSize-0 font-th mt-0">
                                            {{ chkBlankData(formData.inputTel) }}
                                            <b-badge @click="boxPhone = !boxPhone" class="align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputTel" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('PhoneUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- <small class="font-en text-muted">Please specify a telephone number that can be contacted back.</small> -->
                                    <hr>
                                    <!-- <h4 class="mt-2 text-danger font-en font-weight-bold"><u>Description</u></h4> -->
                                    <h5 class="font-en mt-1 mb-2 text-danger font-en font-weight-bold"><u>This information area will not be sent to the company (optional).</u></h5>
                                    <!-- Address -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Address :</h5>
                                    <div v-if="boxAddress" >
                                        <span class="readText f-textSize-1 font-th" v-html="chkBlankData(formData.inputAddress)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxAddress = !boxAddress" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-form-textarea
                                            id="textarea-1"
                                            v-model="formData.inputAddress"
                                            rows="3" max-rows="5"
                                            size="lg"
                                        ></b-form-textarea>
                                        <b-button @click="updateProfile('AddressUp')" size="sm" variant="info" class="mt-2 mb-2 float-right text-capitalize">Update</b-button>
                                    </div>
                                    <!-- About me -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">About me :</h5>
                                    <div v-if="boxAbout" >
                                        <span class="readText f-textSize-1 font-th" v-html="chkBlankData(formData.inputAbout)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxAbout = !boxAbout" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-form-textarea
                                            id="textarea-1"
                                            v-model="formData.inputAbout"
                                            rows="3" max-rows="5"
                                            size="lg"
                                        ></b-form-textarea>
                                        <b-button @click="updateProfile('AboutUp')" size="sm" variant="info" class="mt-2 mb-2 float-right text-capitalize">Update</b-button>
                                    </div>
                                    <!-- Languages -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Language Skills :</h5>
                                    <div v-if="boxLan" >
                                        <span class="readText f-textSize-1 font-th" v-html="chkBlankData(formData.inputLanguages)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxLan = !boxLan" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-form-textarea
                                            id="textarea-1"
                                            v-model="formData.inputLanguages"
                                            rows="3" max-rows="5"
                                            size="lg"
                                        ></b-form-textarea>
                                        <b-button @click="updateProfile('LanUp')" size="sm" variant="info" class="mt-2 mb-2 float-right text-capitalize">Update</b-button>
                                    </div>
                                    <!-- Education -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Education :</h5>
                                    <div v-if="boxEdu" >
                                        <span class="readText f-textSize-1 font-th" v-html="chkBlankData(formData.inputEducation)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxEdu = !boxEdu" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-form-textarea
                                            id="textarea-1"
                                            v-model="formData.inputEducation"
                                            rows="3" max-rows="5"
                                            size="lg"
                                        ></b-form-textarea>
                                        <b-button @click="updateProfile('EduUp')" size="sm" variant="info" class="mt-2 mb-2 float-right text-capitalize">Update</b-button>
                                    </div>
                                    <!-- Skills -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Skills :</h5>
                                    <div v-if="boxSkill" >
                                        <span class="readText f-textSize-1 font-th" v-html="chkBlankData(formData.inputSkills)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxSkill = !boxSkill" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-form-textarea
                                            id="textarea-1"
                                            v-model="formData.inputSkills"
                                            rows="3" max-rows="5"
                                            size="lg"
                                        ></b-form-textarea>
                                        <b-button @click="updateProfile('SkillUp')" size="sm" variant="info" class="mt-2 mb-2 float-right text-capitalize">Update</b-button>
                                    </div>
                                    <!-- 1 -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Facebook :</h5>
                                    <div v-if="boxFace" >
                                        <span class="readText f-textSize-0 font-th" v-html="chkBlankData(formData.inputFacebook)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxFace = !boxFace" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputFacebook" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('faceUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- 2 -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Instagram :</h5>
                                    <div v-if="boxInstagram" >
                                        <span class="readText f-textSize-0 font-th" v-html="chkBlankData(formData.inputInstagram)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxInstagram = !boxInstagram" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputInstagram" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('instagramUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- 3 -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">LinkedIn :</h5>
                                    <div v-if="boxLindIn" >
                                        <span class="readText f-textSize-0 font-th" v-html="chkBlankData(formData.inputLindIn)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxLindIn = !boxLindIn" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputLindIn" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('LindUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                    <!-- 4 -->
                                    <h5 class="mt-3 mb-0 font-en text-muted text-capitalize">Line ID :</h5>
                                    <div v-if="boxLine" >
                                        <span class="readText f-textSize-0 font-th" v-html="chkBlankData(formData.inputLine)" ></span>
                                        <span class="f-textSize-0 font-th mt-0">
                                            <b-badge @click="boxLine = !boxLine" class="mt-1 mb-1 align-top mr-1 ml-1" variant="primary" pill><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-input-group>
                                            <b-form-input v-model="formData.inputLine" type="text" class="font-en" placeholder="Enter..." autocomplete="off" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button @click="updateProfile('LineUp')" size="sm" variant="info" class="text-capitalize">Update</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>
                    </div>
                    <div v-if="pdpaStatus_1 === 'accept' && pdpaStatus_2 === 'accept'" class="col-sm-12 col-lg-12 col-md-12 col-xl-8">
                        <div class="d-flex justify-content-between align-items-center">
                            <h3 class="mt-0 mb-1 font-en text-dark">Preview</h3>
                            <b-button class="mb-2" @click="PrintInfo" size="sm" variant="success"><i class="fa fa-download mr-2" aria-hidden="true" />SAVE RESUME</b-button>
                        </div>
                        <!-- <hr class="mt-1 mb-2"> -->
                        <b-card ref="resumePrint" class="page bg-cc-custom">
                            <b-card-body class="mb-2">
                                <img class="mb-2 mt-0 mb-2" src="@/assets/img/cv-logo-muic.png" alt="MUIC">
                                <div class="row">
                                    <div class="col-sm-12 col-lg-12 col-md-12 col-xl-5">
                                        <!-- image -->
                                        <b-img v-if="file_0" width="150" center thumbnail fluid :src="file_0" alt="Image 1"></b-img>
                                        <b-img v-else blank blank-color="#ccc" center thumbnail fluid width="150" alt="placeholder"></b-img>
                                        <div class="text-center">
                                            <h3 class="text-dark font-th mt-3 mb-0">{{ chkBlankData(formData.inputName) }}</h3>
                                            <h4 class="text-dark font-th mt-2 mb-0">{{ chkBlankData(formData.inputLastName) }}</h4>
                                        </div>
                                        <h4 class="font-en mt-4 mb-3 color-left-1">About me</h4>
                                        <!-- <hr> -->
                                        <p class="text-dark font-th ml-0 mt-1 mb-0">
                                            <span class="readText f-textSize-1">{{ chkBlankData(formData.inputAbout) }}</span>
                                        </p>
                                        <h4 class="font-en mt-4 mb-3 color-left-2">Language Skills</h4>
                                        <!-- <hr> -->
                                        <p class="text-dark font-th text-capitalize ml-0 mt-1 mb-0 f-textSize-1">
                                            <span class="readText f-textSize-1" v-html="chkBlankData(formData.inputLanguages)" ></span>
                                        </p>
                                    </div>
                                    <div class="col-sm-12 col-lg-12 col-md-12 col-xl-7">
                                        <h4 class="font-en mt-4 mb-4 color-left-7">Social Media</h4>
                                        <p v-if="chkBlankData(formData.inputFacebook) !== '-'" class="mt-1 mb-0 font-en text-dark"><i class="fa fa-facebook-official" aria-hidden="true" /> :<span class="ml-3 font-th f-textSize-1 text-dark">{{ chkBlankData(formData.inputFacebook) }}</span></p>
                                        <p v-if="chkBlankData(formData.inputInstagram) !== '-'" class="mt-1 mb-0 font-en text-dark"><i class="fa fa-instagram" aria-hidden="true" /> :<span class="ml-3 font-th f-textSize-1 text-dark">{{ chkBlankData(formData.inputInstagram) }}</span></p>
                                        <p v-if="chkBlankData(formData.inputLindIn) !== '-'" class="mt-1 mb-0 font-en text-dark"><i class="fa fa-linkedin-square" aria-hidden="true" /> :<span class="ml-3 font-th f-textSize-1 text-dark">{{ chkBlankData(formData.inputLindIn) }}</span></p>
                                        <p v-if="chkBlankData(formData.inputLine) !== '-'" class="mt-1 mb-0 font-en text-dark">Line ID :<span class="ml-3 font-th f-textSize-1 text-dark">{{ chkBlankData(formData.inputLine) }}</span></p>
                                        <h4 class="font-en mt-4 mb-4 color-left-4">Education</h4>
                                        <!-- <hr> -->
                                        <p class="mt-1 mb-0 font-en text-dark text-capitalize">Grade :<span class="ml-3 font-th f-textSize-0 text-capitalize text-dark">{{ chkBlankData(formData.inputGpa) }}</span></p>
                                        <p class="mt-1 mb-0 font-en text-dark text-capitalize">Major :<span class="ml-3 font-th f-textSize-0 text-capitalize text-dark">{{ chkBlankData(formData.inputMajor) }}</span></p>
                                        <p class="text-dark font-th text-capitalize ml-0 mt-2 mb-0 f-textSize-1">
                                            <span class="readText f-textSize-1" v-html="chkBlankData(formData.inputEducation)" ></span>
                                        </p>
                                        <h4 class="font-en mt-4 mb-4 color-left-5">Skills</h4>
                                        <!-- <hr> -->
                                        <p class="text-dark font-th text-capitalize ml-0 mt-1 mb-0 f-textSize-1">
                                            <span class="readText f-textSize-1" v-html="chkBlankData(formData.inputSkills)" ></span>
                                        </p>
                                        <h4 class="font-en mt-4 mb-4 color-left-6">Contact</h4>
                                        <!-- <hr> -->
                                        <p class="mt-1 mb-0 font-en text-dark text-capitalize"><i class="fa fa-phone-square mr-2" aria-hidden="true" />Tel :<span class="ml-3 font-th f-textSize-0 text-capitalize text-dark">{{ chkBlankData(formData.inputTel) }}</span></p>
                                        <p class="mt-1 mb-0 font-en text-dark"><i class="fa fa-envelope mr-2" aria-hidden="true" />E-mail :<span class="ml-3 font-th f-textSize-0 text-dark">{{ chkBlankData(formData.inputMail) }}</span></p>
                                        <p class="mt-1 mb-0 font-en text-dark text-capitalize"><i class="fa fa-map-marker mr-2" aria-hidden="true" />Address :</p>
                                        <p class="mt-1 ml-5 mb-0 font-en text-dark">
                                            <span class="readText f-textSize-0 text-dark font-th" v-html="chkBlankData(formData.inputAddress)" ></span>
                                        </p>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>
                        <small class="text-dark mt-3 font-en">Update at : {{ logCrated }}</small>
                    </div>
                </div>
            </b-tab>
            <!-- :disabled="!checkFileAll" -->
            <div v-if="pdpaStatus_1 === 'accept' && pdpaStatus_2 === 'accept'" >
                <b-tab @click="callInfomationCompany" :active="getActiveTab">
                    <template v-slot:title>
                        <h5 class="font-en mt-1 mb-1"><i class="fa fa-building mr-2" aria-hidden="true" />List of Job Vacancies</h5>
                    </template>
                    <b-card>
                        <b-card-body>
                            <b-media class="mb-3">
                                <template #aside>
                                    <img src="@/assets/img/icon_jobfair_2.png" alt="MUIC">
                                </template>
                                <h4 class="font-en mt-3 mb-1">List of Job Vacancies</h4>
                                <p class="font-en">Find the right job and explore your career pathways.</p>
                            </b-media>
                            <!-- <hr> -->
                            <b-form class="mt-3" inline>
                                <label class="thai-font mr-2" for=""><i class="text-dark fa fa-search mr-2" aria-hidden="true" /></label>
                                <b-input 
                                    v-model="filter"
                                    style="width:50%"
                                    type="search" 
                                    size="sm"
                                    id="filterInput-2" 
                                    class="thai-font mb-2 mr-sm-2 mb-sm-0" placeholder="Search..."
                                ></b-input>
                            </b-form>
                            <b-table 
                                ref="selectableTableCompany"
                                :fields="fields" 
                                :items="itemDataCompany"
                                :filter="filter"
                                @filtered="onFiltered"
                                responsive
                                head-variant="dark"
                                :busy="loadingTable"
                                small show-empty bordered striped
                                class="mt-3"
                            >
                                <template v-slot:cell(company)="row">
                                    <b-media>
                                        <!-- <template #aside></template> -->
                                        <img 
                                            v-if="row.item.logo !== null && row.item.logo !== 'null' && row.item.logo !== '' && row.item.logo !== 'NONE'" 
                                            :src="row.item.logo" 
                                            class="img-64" 
                                            alt="IMAGE-COMPANY"
                                        />
                                        <b-img v-else blank blank-color="#ccc" class="img-64" alt="placeholder"></b-img>
                                        <h5 class="font-en mt-1 mb-0">
                                            <strong>{{ row.item.name }}</strong>
                                        </h5>
                                        <div v-if="row.item.reg_type === 'in'">
                                            <div v-if="row.item.detail !== '' && row.item.detail !== null && row.item.detail !== '-'">
                                                <small class="text-muted font-en">Detail</small>
                                                <p class="readText font-small-detail font-th mb-1" v-html="row.item.detail"></p>
                                            </div>
                                        </div>
                                    </b-media>
                                </template>
                                <template v-slot:cell(status)="row">
                                    <strong class="font-en text-capitalize">{{ row.item.status }}</strong>
                                </template>
                                <template v-slot:cell(sendmail)="row">
                                    <div v-if="row.item.reg_type === 'out'">
                                        <span class="font-small-detail font-weight-bold font-th mb-1 text-r" v-html="row.item.detail"></span>
                                    </div>
                                    <div v-else>
                                        <span v-for="(item, indexDetail) in FilterDataPosition(row.item.id)" :key="'eventL'+ indexDetail" >
                                            <p class="font-th mt-1 mb-1">
                                                <u><b-link @click="nextPageDetail(row.item.id)" class="font-th mt-1 mb-1">[ {{ item.position_type }} ] : {{ item.position_name }}<i class="align-top ml-1 fa fa-external-link" aria-hidden="true" /></b-link></u>
                                            </p>
                                        </span>
                                    </div>
                                </template>
                                <template v-slot:table-busy>
                                    <div class="text-center text-danger my-2 font-en">
                                        <b-spinner class="align-middle mr-2"></b-spinner>&nbsp;<strong>Loading company infomation...</strong>
                                    </div>
                                </template>
                            </b-table>
                        </b-card-body>
                    </b-card>
                </b-tab>
                <b-tab @click="callInformationSubmit">
                    <template v-slot:title >
                        <h5 class="font-en mt-1 mb-1"><i class="fa fa-folder mr-2" aria-hidden="true" />Application History</h5>
                    </template>
                    <b-card>
                        <b-card-body>
                            <b-form class="mt-3" inline>
                                <label class="thai-font mr-2" for=""><i class="text-dark fa fa-search mr-2" aria-hidden="true" /></label>
                                <b-input 
                                    v-model="filterApply"
                                    type="search" 
                                    size="sm"
                                    id="filterInput" 
                                    class="thai-font mb-2 mr-sm-2 mb-sm-0" placeholder="Search..."
                                ></b-input>
                            </b-form>
                            <b-table 
                                ref="TableCompanyApply"
                                :fields="fieldsHistory" 
                                :items="itemAppleHistory"
                                :filter="filterApply"
                                @filtered="onFiltered"
                                responsive="sm"
                                head-variant="dark"
                                :busy="loadApply"
                                small show-empty bordered striped
                                class="mt-3"
                            >
                                <template v-slot:cell(request)="row">
                                    <h5 class="font-en mt-1 mb-0">
                                        <strong>{{ row.item.id }}</strong>
                                    </h5>
                                </template>
                                <template v-slot:cell(company)="row">
                                    <h5 class="font-en mt-1 mb-0">
                                        <strong>{{ row.item.name }}</strong>
                                    </h5>
                                </template>
                                <template v-slot:cell(position)="row">
                                    <h5 class="font-th mt-1 mb-0">
                                        <strong>{{ row.item.position_name }}</strong>
                                    </h5>
                                </template>
                                <template v-slot:cell(statussubmit)="row">
                                    <h5 class="font-en text-capitalize mt-1 mb-0">
                                        <strong>{{ row.item.status === 'wait' ? 'Waiting' : row.item.status }}</strong>
                                    </h5>
                                </template>
                                <!-- remove -->
                                <template v-slot:cell(remove)="row">
                                    <span v-if="row.item.status === 'wait' || row.item.status === 'reject'">
                                        <b-button @click="DelApply(row.item.id)" size="sm" class="mb-2" variant="danger"><i class="fa fa-trash" aria-hidden="true"></i></b-button>
                                    </span>
                                </template>
                                <template v-slot:table-busy>
                                    <div class="text-center text-danger my-2 font-en">
                                        <b-spinner class="align-middle mr-2"></b-spinner>&nbsp;<strong>Loading company infomation apply...</strong>
                                    </div>
                                </template>
                            </b-table>
                        </b-card-body>
                        <p class="ml-3 font-weight-bold mt-2 mb-3">
                            Please help us improve our online job application by 24 February 2023 at
                            <a rel="noopener noreferrer" target="_blank" href="https://forms.gle/FYpUwhaxtYcn4Uwe8" class="text-primary">https://forms.gle/FYpUwhaxtYcn4Uwe8.</a>
                        </p>
                    </b-card>
                </b-tab>
            </div>
        </b-tabs>
    </div>
</template>

<script>
    const formResume = {
        inputName:'',
        inputLastName:'',
        inputNation:'',
        inputMajor:'',
        inputMail:'',
        inputGpa: 0.00,
        inputArea:'',
        inputTel:'',
        FilePhoto:null,
        FileTranscript:null,
        FileCv:null,
        FileCerificate:null,
        // other data
        inputAbout:'',
        inputLanguages:'',
        inputEducation:'',
        inputSkills:'',
        inputAddress:'',
        inputFacebook:'',
        inputInstagram:'',
        inputLindIn:'',
        inputLine:'',
    }
    export default {
        data(){
            return{
                max:10,
                visibleCollege: true,
                checkAttTab:'',
                pdpaStatus_1:'',
                pdpaStatus_2:'',
                loadingTable:false,
                file_0:null,
                file_1:null,
                file_2:null,
                file_3:null,
                boxName:true,
                boxLastName:true,
                boxNational:true,
                boxMajor:true,
                boxMail:true,
                boxGpa:true,
                boxArea:true,
                boxPhone:true,
                // box other
                boxAbout:true,
                boxLan:true,
                boxEdu:true,
                boxSkill:true,
                boxAddress:true,
                boxFace:true,
                boxInstagram:true,
                boxLindIn:true,
                boxLine:true,
                // 
                formData: Object.assign({}, formResume),
                status: 'not_accepted',
                errorMsgs:[],
                filter: null,
                filterOn: [],
                filterApply: null,
                filterApplyOn: [],
                itemDataPosition:[],
                arrPosition:[],
                itemDataCompany:[],
                fields: [ 
                    { 
                        key: 'company',
                        label: 'Company',
                        class: 'w-50',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                    { 
                        key: 'sendmail',
                        label: 'Job Position',
                        class: 'w-50',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                ],
                logCrated: null,
                loadApply:false,
                itemAppleHistory: [],
                fieldsHistory: [ 
                    { 
                        key: 'request',
                        label: 'Request ID',
                        class: 'text-center w-5',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                    { 
                        key: 'company',
                        label: 'List of Company',
                        class: 'w-50',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                    { 
                        key: 'position',
                        label: 'Apply for a position',
                        class: 'bg-success-custom-th w-30',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                    { 
                        key: 'statussubmit',
                        label: 'Status',
                        class: 'text-center w-10',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                    { 
                        key: 'remove',
                        label: '',
                        class: 'text-center w-5',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                ],
                errorImage:'',
                errorPdfFile:'',
                errorPdfFileTranscript:'',
                errorPdfFileCerificate:'',
                // size
                size_file_certificate: 0,
                size_file_img: 0,
                size_file_resume: 0,
                size_file_transcipt: 0,
                size_file_sum: 0,
            }
        },
        computed: {
            getActiveTab(){
                if(this.$route.params.tabAc  === 'aciveTab2'){
                    this.callInfomationCompany()
                    return true
                }else{ 
                    return false
                }
            },
            rows() {
                return this.itemDataCompany.length
            },
            sortOptions() {
                return this.fields.filter(f => f.sortable).map(f => {
                    return { text: f.label, value: f.key }
                })
            },
            sumAllFile(){
                return this.size_file_sum = parseFloat(this.size_file_certificate)+parseFloat(this.size_file_img)+parseFloat(this.size_file_resume)+parseFloat(this.size_file_transcipt)
            },
        },
        mounted(){
            this.callProfile()
            this.getFileSum()
        },
        methods:{
            async valConsent(val){
                try {
                    const setConsent = new FormData()
                    setConsent.append('pdpa', val)
                    const updateConsent = await this.$http.patch(`/career/application/update_data/`, setConsent,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(updateConsent.status === 200){ 
                        this.pdpaStatus_1 = val
                        if(val === 'not accept'){
                            this.valConsentCompany(val)
                        }
                    }
                } catch (error) {}
            },
            async valConsentCompany(val){
                try {
                    const setConsentCompany = new FormData()
                    setConsentCompany.append('pdpa_sent_to', val)
                    const updateConsentCompany = await this.$http.patch(`/career/application/update_data/`, setConsentCompany,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(updateConsentCompany.status === 200){ 
                        this.pdpaStatus_2 = val
                    }
                } catch (error) {}
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            chkBlankData(val){
                return val !== "NONE" && val !== null && val !== 'null' && val !== "" ? val : '-'
            },
            chkBlankMail(val){
                return val !== "NONE" && val !== null && val !== 'null' && val !== "" ? val : 'example@mail.com'
            },
            getFileExtension(filename)
            {
                if(filename){
                    return filename.type === 'application/pdf'
                }
            },
            getFileExtensionCerificate(filename)
            {
                // if(filename){
                //     var ext = /^.+\.([^.]+)$/.exec(filename.name);
                //     var chk = ext == null ? "" : ext[1].toLowerCase()
                //     return chk === 'pdf' || chk ===  'zip' || chk ===  'rar'
                // }
                if(filename){
                    return filename.type === 'application/pdf' || filename.type === 'application/x-zip-compressed'
                }
            },
            getFileExtensionImage(filename)
            {
                if(filename){
                    return filename.type === 'image/jpg' || filename.type === 'image/jpeg' || filename.type === 'image/png'
                }
            },
            NotiiDataPeriodsshow(dataUpdateAt){
                var a = this.moment(dataUpdateAt).add(6, 'months').valueOf()
                var c = this.moment().valueOf()
                // return 'day + 180 : '+a+' now : '+c
                if(c >= a){
                    return true
                }else{
                    return false
                }
            },
            async callInfomationCompany(){
                this.loadingTable = true
                this.itemDataCompany = []
                const res = await this.$http.get(`/career/company/`)
                if(res.status === 200){
                    try {
                        this.itemDataCompany = res.data.map(item => {
                            this.callInfomationCompanyPosition(item.id)
                            return {
                                'id': item.id,
                                'name': item.name,
                                'email': item.email,
                                'tel': item.tel,
                                'detail': item.detail,
                                'reg_type': item.reg_type,
                                'logo': item.logo,
                            }
                        })
                        this.itemDataCompany.sort(function(a, b) {
                            var nameA = a.name.toUpperCase();
                            var nameB = b.name.toUpperCase();
                            if (nameA < nameB) { return -1; }
                            if (nameA > nameB) { return 1; }
                            return 0;
                        });
                        this.loadingTable = false
                    } catch (error) { this.loadingTable = false }
                }
            },
            async callInfomationCompanyPosition(idCompany){
                // this.itemDataPosition = []
                try {
                    const resPosition = await this.$http.get(`/career/company/${idCompany}/job/`)
                    if(resPosition.status === 200){
                        // console.log(resPosition.data)
                        this.itemDataPosition.push({
                            'companyId':idCompany,
                            'dataPos': resPosition.data
                        })
                    }
                    // console.log(this.itemDataPosition)
                } catch (error) {}
            },
            FilterDataPosition(idComapanyFilter){
                // console.log(this.itemDataPosition)
                // this.arrPosition = []
                for (let b = 0; b < this.itemDataPosition.length; b++) {
                    if(this.itemDataPosition[b].companyId === idComapanyFilter){
                        return this.itemDataPosition[b].dataPos
                    }
                }
            },
            nextPageDetail(idCompany){
                this.$router.push({
                    name:"Company Detail",
                    params: { 
                        id: idCompany,
                    }, 
                }).catch(err => {})
            },
            formatMb(bytes){
                bytes = (bytes / 1048576).toFixed(2)
                return bytes
            },
            async getFileSum(){
                try {
                    const res = await this.$http.get(`/career/application/get_file_size/`)
                    if(res.status === 200){
                        this.size_file_certificate = parseFloat(this.formatMb(res.data.file_certificate))
                        this.size_file_img = parseFloat(this.formatMb(res.data.file_img))
                        this.size_file_resume = parseFloat(this.formatMb(res.data.file_resume))
                        this.size_file_transcipt = parseFloat(this.formatMb(res.data.file_transcipt))
                    }
                } catch (error) { } 
            },
            // profile
            async callProfile(){
                try {
                    const resProfile = await this.$http.get(`/career/application/`)
                    if(resProfile.status === 200){
                        // console.log(resProfile.data)
                        this.file_0 = resProfile.data[0].file_img
                        this.file_1 = resProfile.data[0].file_transcipt
                        this.file_2 = resProfile.data[0].file_resume
                        this.file_3 = resProfile.data[0].file_certificate
                        this.formData.inputName = resProfile.data[0].name
                        this.formData.inputLastName = resProfile.data[0].surname
                        this.formData.inputMail = resProfile.data[0].email
                        this.formData.inputNation = resProfile.data[0].nationality
                        this.formData.inputMajor = resProfile.data[0].major
                        this.formData.inputGpa = resProfile.data[0].gpa
                        this.formData.inputArea = resProfile.data[0].area_of_interest
                        this.formData.inputTel = resProfile.data[0].tel
                        this.formData.inputAbout = resProfile.data[0].about_me
                        this.formData.inputLanguages = resProfile.data[0].language
                        this.formData.inputEducation = resProfile.data[0].education
                        this.formData.inputSkills = resProfile.data[0].skill
                        this.formData.inputAddress = resProfile.data[0].address
                        this.formData.inputFacebook = resProfile.data[0].facebook
                        this.formData.inputInstagram = resProfile.data[0].instagram
                        this.formData.inputLindIn = resProfile.data[0].linkedin
                        this.formData.inputLine = resProfile.data[0].line
                        this.logCrated = this.moment(resProfile.data[0].updated_at).format('LLL')
                        this.pdpaStatus_1 = resProfile.data[0].pdpa
                        this.pdpaStatus_2 = resProfile.data[0].pdpa_sent_to
                    }else if(resProfile.status === 204){
                        // console.log(resProfile.status)
                        try {
                            const setProfile = new FormData()
                            const resMe = await this.$http.get(`/student/profile/me/`)
                            if(resMe.status === 200){
                                // console.log(resMe.data)
                                // setProfile.append('student_id', resMe.data.student_id)
                                // setProfile.append('area_of_interest', '-')
                                // setProfile.append('pdpa', 'not accept')
                                // setProfile.append('pdpa_sent_to', 'not accept')
                                // send first data
                                setProfile.append('name', this.chkBlankData(resMe.data.english_first_name))
                                setProfile.append('surname', this.chkBlankData(resMe.data.english_last_name))
                                setProfile.append('nationality', this.chkBlankData(resMe.data.nationality))
                                setProfile.append('major', this.chkBlankData(resMe.data.main_curriculum_general_name))
                                setProfile.append('gpa', 0.00)
                                setProfile.append('tel', this.chkBlankData(resMe.data.main_contact_detail_mobile_number))
                                setProfile.append('email', this.chkBlankMail(resMe.data.admission_email))
                                try {
                                    const response = await this.$http.post('/career/application/', setProfile,{
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                    })
                                    if(response.status === 201){
                                        this.formData.inputName = resMe.data.english_first_name
                                        this.formData.inputLastName = resMe.data.english_last_name
                                        this.formData.inputMail = resMe.data.admission_email
                                        this.formData.inputNation = resMe.data.nationality
                                        this.formData.inputMajor = resMe.data.main_curriculum_general_name
                                        this.formData.inputGpa = 0.00
                                        this.formData.inputArea = '-'
                                        this.formData.inputTel = resMe.data.main_contact_detail_mobile_number
                                        this.formData.inputAddress = resMe.data.main_contact_detail_address
                                        this.pdpaStatus_1 = response.data.pdpa
                                        this.pdpaStatus_2 = response.data.pdpa_sent_to
                                    }
                                } catch (error) {}
                            }
                        } catch (error) {}
                    }
                } catch (error) {}
            },
            // patch profile 
            async updateProfile(caseCheck){
                try {
                    const sendFormUpdate = new FormData()
                    if(caseCheck === 'nameUp'){ sendFormUpdate.append('name', this.chkBlankData(this.formData.inputName)) }
                    else if(caseCheck === 'lastnameUp'){ sendFormUpdate.append('surname', this.chkBlankData(this.formData.inputLastName)) }
                    else if(caseCheck === 'mailUp'){ sendFormUpdate.append('email', this.chkBlankData(this.formData.inputMail)) }
                    else if(caseCheck === 'nationalUp'){ sendFormUpdate.append('nationality', this.chkBlankData(this.formData.inputNation)) }
                    else if(caseCheck === 'majorUp'){ sendFormUpdate.append('major', this.chkBlankData(this.formData.inputMajor)) }
                    else if(caseCheck === 'gradeUp'){ sendFormUpdate.append('gpa', this.chkBlankData(this.formData.inputGpa)) }
                    else if(caseCheck === 'AreaUp'){ sendFormUpdate.append('area_of_interest', this.chkBlankData(this.formData.inputArea)) }
                    else if(caseCheck === 'PhoneUp'){ sendFormUpdate.append('tel', this.chkBlankData(this.formData.inputTel)) }
                    else if(caseCheck === 'AboutUp'){ sendFormUpdate.append('about_me', this.chkBlankData(this.formData.inputAbout)) }
                    else if(caseCheck === 'LanUp'){ sendFormUpdate.append('language', this.chkBlankData(this.formData.inputLanguages)) }
                    else if(caseCheck === 'EduUp'){ sendFormUpdate.append('education', this.chkBlankData(this.formData.inputEducation)) }
                    else if(caseCheck === 'SkillUp'){ sendFormUpdate.append('skill', this.chkBlankData(this.formData.inputSkills)) }
                    else if(caseCheck === 'AddressUp'){ sendFormUpdate.append('address', this.chkBlankData(this.formData.inputAddress)) }
                    else if(caseCheck === 'faceUp'){ sendFormUpdate.append('facebook', this.chkBlankData(this.formData.inputFacebook)) }
                    else if(caseCheck === 'instagramUp'){ sendFormUpdate.append('instagram', this.chkBlankData(this.formData.inputInstagram)) }
                    else if(caseCheck === 'LindUp'){ sendFormUpdate.append('linkedin', this.chkBlankData(this.formData.inputLindIn)) }
                    else if(caseCheck === 'LineUp'){ sendFormUpdate.append('line', this.chkBlankData(this.formData.inputLine)) }
                    // api send 
                    const updateProfile = await this.$http.patch(`/career/application/update_data/`, sendFormUpdate,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(updateProfile.status === 200){
                        if(caseCheck === 'nameUp'){ this.boxName = !this.boxName }
                        else if(caseCheck === 'lastnameUp'){ this.boxLastName = !this.boxLastName }
                        else if(caseCheck === 'mailUp'){ this.boxMail = !this.boxMail }
                        else if(caseCheck === 'nationalUp'){ this.boxNational = !this.boxNational }
                        else if(caseCheck === 'majorUp'){ this.boxMajor = !this.boxMajor }
                        else if(caseCheck === 'gradeUp'){ this.boxGpa = !this.boxGpa }
                        else if(caseCheck === 'AreaUp'){ this.boxArea = !this.boxArea }
                        else if(caseCheck === 'PhoneUp'){ this.boxPhone = !this.boxPhone }
                        else if(caseCheck === 'AboutUp'){ this.boxAbout = !this.boxAbout }
                        else if(caseCheck === 'LanUp'){ this.boxLan = !this.boxLan }
                        else if(caseCheck === 'EduUp'){ this.boxEdu = !this.boxEdu }
                        else if(caseCheck === 'SkillUp'){ this.boxSkill = !this.boxSkill }
                        else if(caseCheck === 'AddressUp'){ this.boxAddress = !this.boxAddress }
                        else if(caseCheck === 'faceUp'){ this.boxFace = !this.boxFace  }
                        else if(caseCheck === 'instagramUp'){ this.boxInstagram = !this.boxInstagram  }
                        else if(caseCheck === 'LindUp'){ this.boxLindIn = !this.boxLindIn  }
                        else if(caseCheck === 'LineUp'){ this.boxLine = !this.boxLine  }
                        this.logCrated = this.moment(updateProfile.data.updated_at).format('LLL')
                    }
                } catch (error) {}
            },
            // upload file 
            async UploadfileData(event , caseCheckUp){
                // console.log(this.getFileExtension(event.target.files[0]))
                // console.log(event.target.files[0])
                // console.log(caseCheckUp)
                this.errorPdfFile = ''
                this.errorImage = ''
                this.errorPdfFileTranscript = ''
                this.errorPdfFileCerificate = ''
                try {
                    const sendFormUpdateFile = new FormData()
                    if(caseCheckUp === 'photo'){ 
                        if(this.getFileExtensionImage(event.target.files[0])){
                            if(this.sumAllFile <= this.max){
                                sendFormUpdateFile.append('file_img', event.target.files[0]) 
                                try {
                                    const updateFile = await this.$http.patch(`/career/application/update_data/`, sendFormUpdateFile,{
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                    })
                                    if(updateFile.status === 200){ 
                                        this.size_file_img = ((event.target.files[0].size / (1024*1024)).toFixed(2))
                                        this.file_0 = true
                                    }else{
                                        throw { updateFile }
                                    }
                                } catch (error) { this.errorImage = 'max all file 10 mb' }
                            }else{
                                this.errorImage = 'max all file 10 mb'
                            }
                        }else{
                            this.errorImage = '.png .jpg .jpeg Only'
                        }
                    }
                    else if(caseCheckUp === 'Transcript'){ 
                        if(this.getFileExtension(event.target.files[0])){
                            if(this.sumAllFile <= this.max){
                                sendFormUpdateFile.append('file_transcipt', event.target.files[0]) 
                                try {
                                    const updateFile = await this.$http.patch(`/career/application/update_data/`, sendFormUpdateFile,{
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                    })
                                    if(updateFile.status === 200){ 
                                        this.size_file_transcipt = ((event.target.files[0].size / (1024*1024)).toFixed(2))
                                        this.file_1 = true
                                    }else{
                                        throw { updateFile }
                                    }
                                } catch (error) { this.errorPdfFileTranscript = 'max all file 10 mb' }
                            }else{ this.errorPdfFileTranscript = 'max all file 10 mb' }
                        }else{ this.errorPdfFileTranscript = '.pdf Only' }
                    }
                    else if(caseCheckUp === 'Resume'){ 
                        if(this.getFileExtension(event.target.files[0])){
                            if(this.sumAllFile <= this.max){
                                sendFormUpdateFile.append('file_resume', event.target.files[0]) 
                                try {
                                    const updateFile = await this.$http.patch(`/career/application/update_data/`, sendFormUpdateFile,{
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                    })
                                    if(updateFile.status === 200){ 
                                        this.size_file_resume = ((event.target.files[0].size / (1024*1024)).toFixed(2))
                                        this.file_2 = true
                                    }else{
                                        throw { updateFile }
                                    }
                                } catch (error) { this.errorPdfFile = 'max all file 10 mb' }
                            }else{ this.errorPdfFile = 'max all file 10 mb' }
                        }else{ this.errorPdfFile = '.pdf Only' }
                    }
                    else if(caseCheckUp === 'Certificate'){ 
                        if(this.getFileExtensionCerificate(event.target.files[0])){
                            if(this.sumAllFile <= this.max){
                                sendFormUpdateFile.append('file_certificate', event.target.files[0])
                                try {
                                    const updateFile = await this.$http.patch(`/career/application/update_data/`, sendFormUpdateFile,{
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                    })
                                    if(updateFile.status === 200){ 
                                        this.size_file_certificate = ((event.target.files[0].size / (1024*1024)).toFixed(2))
                                        this.file_3 = true
                                    }else{
                                        throw { updateFile }
                                    }
                                } catch (error) { this.errorPdfFileCerificate = 'max all file 10 mb' }
                            }else{
                                this.errorPdfFileCerificate = 'max all file 10 mb'
                            }
                        }else{
                            this.errorPdfFileCerificate = '.pdf , .zip Only'
                        }
                    }
                } catch (error) {}
            },
            // delete file
            async delfileData(caseDel){
                try {
                    const sendFormDelFile = new FormData()
                    if(caseDel === 'delImage'){ sendFormDelFile.append('file_img', '') }
                    else if(caseDel === 'delTranscript'){ sendFormDelFile.append('file_transcipt', '') }
                    else if(caseDel === 'delResume'){ sendFormDelFile.append('file_resume', '') }
                    else if(caseDel === 'delCertificate'){ sendFormDelFile.append('file_certificate', '') }
                    const updateFile = await this.$http.patch(`/career/application/update_data/`, sendFormDelFile,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(updateFile.status === 200){
                        this.getFileSum()
                        if(caseDel === 'delImage'){ this.file_0 = updateFile.data.file_img }
                        else if(caseDel === 'delTranscript'){ this.file_1 = updateFile.data.file_transcipt }
                        else if(caseDel === 'delResume'){ this.file_2 = updateFile.data.file_resume }
                        else if(caseDel === 'delCertificate'){ this.file_3 = updateFile.data.file_certificate }
                    }
                } catch (error) {}
            },
            // history check
            async callInformationSubmit(){
                this.loadApply = true
                this.itemAppleHistory = []
                try {
                    const resApply = await this.$http.get(`/career/submit/`)
                    if(resApply.status === 200){
                        this.itemAppleHistory = resApply.data.map(item => {
                            return {
                                'id': item.id,
                                'status': item.status,
                                'position_name': item.position_detail.position_name,
                                'logo': item.position_detail.company_detail.logo,
                                'name': item.position_detail.company_detail.name,
                                'detail': item.position_detail.company_detail.detail,
                            }
                        })
                        this.itemAppleHistory.sort((a, b) =>{ return b.id - a.id; });
                    }
                    this.loadApply = false
                } catch (error) {
                    this.loadApply = false
                }
            },
            // remove apply
            async DelApply(idSubmitApply){
                try {
                    const res = await this.$http.delete(`/career/submit/${idSubmitApply}/remove/`)
                    if(res.status === 203){
                        this.callInformationSubmit()
                    }
                } catch (error) {}
            },
            async PrintInfo(){
                const el = this.$refs.resumePrint;
                const options = {
                    type: 'dataURL'
                }
                this.imagePrintInfo = await this.$html2canvas(el, options);
                var a = document.createElement("a"); //Create <a>
                a.href = this.imagePrintInfo; //Image Base64 Goes here
                a.download = `MUIC-resume.png`; //File name Here
                a.click(); //Downloaded file
            }
        }
    }
</script>

<style lang="scss" scoped>
    .hide-load-upfile{ display: none; }
    .form-control {
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
        background-color:#ffffff;
        border: 1px solid #ced4da;
    }
    .font-th{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Baloo Tamma 2', cursive; }
    .info{ background-color: #b4d8fc; };
    .alert-danger {
        background-color: #f1d1d1;
        color: #000000;
    }
    .f-textSize-0{ font-size: 1.25rem; }
    .f-textSize-1{ font-size: 0.85rem; }
    .w-5{ width: 5%; }
    .w-15{ width: 15%; }
    .w-20{ width: 20%; }
    .w-30{ width: 30%; }
    .w-35{ width: 35%; }
    .w-40{ width: 40%; }
    .w-50{ width: 50%; }
    .w-60{ width: 60%; }
    .alert-success-cus {
        background-color: #d9ffee;
        color: #229863;
    }
    .font-small-detail{ font-size: 0.95rem; }
    .readText{ white-space: pre-line; }
    .color-left-1{ 
        border-left: 5px solid #93b6ff;
        border-bottom: 2px solid #93b6ff;
        background-color: #f6f6ff;
        padding:7px;
    }
    .color-left-2{ 
        border-left: 5px solid #b9c787;
        border-bottom: 2px solid #b9c787;
        background-color: #f6f6ff;
        padding:7px;
    }
    .color-left-3{ 
        border-left: 5px solid #000;
        border-bottom: 2px solid #000;
        background-color: #f6f6ff;
        padding:7px;
    }
    .color-left-4{ 
        border-left: 5px solid #fb9898;
        border-bottom: 2px solid #fb9898;
        background-color: #f6f6ff;
        padding:7px;
    }
    .color-left-5{ 
        border-left: 5px solid #7a69b7;
        border-bottom: 2px solid #7a69b7;
        background-color: #f6f6ff;
        padding:7px;
    }
    .color-left-6{ 
        border-left: 5px solid #dc9431;
        border-bottom: 2px solid #dc9431;
        background-color: #f6f6ff;
        padding:7px;
    }
    .color-left-7{ 
        border-left: 5px solid #9da7fd;
        border-bottom: 2px solid #8895ff;
        background-color: #f6f6ff;
        padding:7px;
    }
    .bg-cc-custom{ 
        // background-image: linear-gradient(-20deg, #1d2f3c 0%, #37324c 100%) !important; 
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/img/bg-resume.png");
    }
    .bg-success-custom-th{
        background-color: #cef5d7 !important;
        color: #000;
    }
    .text-blue-cus{ color: rgb(27, 99, 167); }
    .text-red-cus{ color: rgb(253, 81, 81); }
    // a4 size
    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .img-64{
            height:35px;
        }
    }
    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .img-64{
            height:40px;
        }
    }
    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .img-64{
            height:45px;
        }
    }
    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 1300px) and (max-width:1500px) {
        .img-64{
            height:50px;
        }
    } 
    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1501px) {
        .page {
            width: 210mm;
            min-height: 297mm;
            padding: 5mm;
            margin: 10mm auto;
            border: 1px #D3D3D3 solid;
            border-radius: 5px;
            // // background: white;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        }
    }
    @page {
        size: A4;
        margin: 0;
    }
    .text-r {
        white-space: pre-wrap;
    }
</style>